import React from "react";

function Pagination({firstOrder, endOrder, clickForward, clickBackward, choosePage, page, totalpage }) {
  return (
    <>
        <ul className="flex items-center overflow-auto">
          <li>
            <button
              onClick={firstOrder}
              className="flex items-center justify-center px-4 h-10 ms-0 leading-tight text-black bg-white border-gray-300 rounded-s-lg"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M11 7l-5 5l5 5" />
                <path d="M17 7l-5 5l5 5" />
              </svg>
            </button>
          </li>
          <li>
            <button
              className="flex items-center justify-center px-4 h-10 ms-0 leading-tight text-gray-700 bg-white border-gray-300 rounded-s-lg"
              onClick={clickBackward}
            >
              <svg
                className="w-3 h-3 rtl:rotate-180"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 6 10"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 1 1 5l4 4"
                />
              </svg>
            </button>
          </li>
 

          {Array.from({ length: totalpage }, (_, index) => index + 1).map(
            (number) =>
              (number === page && (
                <li>
                  <button
                    href="#"
                    className="flex items-center justify-center px-4 h-10 leading-tight font-bold text-[#fff] rounded-full bg-orange-500"
                    
                  >
                    {number}
                  </button>
                </li>
              )) ||
              (number !== page && (
                <li>
                  <button
                    className="flex items-center justify-center px-4 h-10 leading-tight font-bold text-black"
                    onClick={() => choosePage(number)}
                  >
                    {number}
                  </button>
                </li>
              ))
          )}

          <li>
            <button
              className="flex items-center justify-center px-4 h-10 leading-tight text-gray-700 bg-white rounded-e-lg"
              onClick={clickForward}
            >
              <span className="sr-only">Next</span>
              <svg
                className="w-3 h-3 rtl:rotate-180"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 6 10"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 9 4-4-4-4"
                />
              </svg>
            </button>
          </li>
          <li>
            <button
              className="flex items-center justify-center px-4 h-10 leading-tight text-black bg-white rounded-e-lg"
              onClick={endOrder}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M7 7l5 5l-5 5" />
                <path d="M13 7l5 5l-5 5" />
              </svg>
            </button>
          </li>
        </ul>
    </>
  );
}

export default Pagination;
